

















































































































































































































































































































































import { LANG } from "@/common/constant";
import { formatImageUrl, getAttributeByLangSnakeCase } from "@/common/utils";
import $ from "jquery";
import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.svg");

@Component({
  name: "BlogPreviewComponent",
  components: {},
})
export default class BlogPreviewComponent extends Vue {
  public article: any = {};
  get noImageUrl() {
    return noImage;
  }

  public async mounted() {
    const news = localStorage.getItem("article");
    this.article = JSON.parse(news);
    this.$nextTick(() => {
      $(".QuillArea iframe.ql-video").each(function() {
        if (!$(this).parent().is("div.mb__movie-wrap")) {
          const newDiv = $('<div class="mb__movie-wrap">');
          $(this).wrap(newDiv);
        }
      });
    });
  }

  public formatImageUrl(fileName, size = "1600x800") {
    return fileName ? formatImageUrl(fileName, size) : noImage;
  }

  public getContentByLang(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangSnakeCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangSnakeCase(object, attributeName, LANG.JA);
  }

  public translateAttribute(attributeName) {
    const currentLang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }
}
